<div class="face">
  <ng-content />
</div>
